module.exports = __webpack_public_path__ + "static/media/ye_guang_gu_jia.4ab5c19f.png";